var map = {
	"./1.jpg": "xFS9",
	"./2.jpg": "vceQ",
	"./3.jpg": "eyc7",
	"./4.jpg": "nVRt"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "w7eE";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-img ^\.\/.*\.jpg$
// module id = w7eE
// module chunks = 1